import React, { useState } from 'react';
import { BookmarkIcon } from 'lucide-react';
import { useDarkClasses } from '../../hooks/useDarkClasses';
interface SaveToTrackerProps {
  productId: string;
  initialSaved?: boolean;
  className?: string;
}
const SaveToTracker: React.FC<SaveToTrackerProps> = ({
  productId,
  initialSaved = false,
  className = ''
}) => {
  const dk = useDarkClasses();
  const [isSaved, setIsSaved] = useState(initialSaved);
  const handleSave = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsSaved(!isSaved);
  };
  return <button onClick={handleSave} className={`p-2 rounded-full transition-all duration-200 shadow-sm ${isSaved ? 'bg-indigo-600 text-white hover:bg-indigo-700' : dk.isDark ? 'bg-gray-800/90 text-gray-400 hover:bg-gray-700 hover:text-indigo-400' : 'bg-white/90 text-gray-500 hover:bg-white hover:text-indigo-600'} ${className}`} aria-label={isSaved ? 'Remove from tracker' : 'Save to tracker'} title={isSaved ? 'Saved to tracker' : 'Save to tracker'} data-id="element-3890" data-mp="2wkur4iz87dns">
      <BookmarkIcon className={`h-5 w-5 ${isSaved ? 'fill-current' : ''}`} data-id="element-3891" data-mp="2zj8lo5tbgvnt" />
    </button>;
};
export default SaveToTracker;